var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_vm._t("default",null,{"isOnline":_vm.isOnline,"device":_vm.device,"employee":_vm.employee,"loading":_vm.loading,"allowLiveView":_vm.allowLiveView})],2)}
var staticRenderFns = []

export { render, staticRenderFns }